import React from 'react';

interface Props {
  width?: number;
  height?: number;
}

const Image = ({ width = 48, height = 47 }: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#a)">
      <path
        d="M40.923.5H7.077A3.077 3.077 0 0 0 4 3.577v33.846c0 1.7 1.378 3.077 3.077 3.077h33.846c1.7 0 3.077-1.378 3.077-3.077V3.577C44 1.877 42.622.5 40.923.5Z"
        fill="#4392F1"
      />
    </g>
    <path
      d="M4 3.577A3.077 3.077 0 0 1 7.077.5H29.6l-9.6 40H7.077A3.077 3.077 0 0 1 4 37.423V3.577Z"
      fill="#236EC9"
    />
    <g filter="url(#b)">
      <path
        d="M16.446 22.588a1.537 1.537 0 0 1 2.61 0L24 30.501H11.5l4.945-7.913h.001Z"
        fill="#6DD8D8"
      />
    </g>
    <g filter="url(#c)">
      <path
        d="M26.374 15.753a1.538 1.538 0 0 1 2.752 0L36.5 30.501H19l4.375-8.751 3-5.997h-.001Z"
        fill="#59C3C3"
      />
    </g>
    <g filter="url(#d)">
      <path d="M17.75 18.002a3.75 3.75 0 1 0 0-7.502 3.75 3.75 0 0 0 0 7.502Z" fill="#FFC857" />
    </g>
    <defs>
      <filter
        id="a"
        x=".846"
        y=".5"
        width="46.308"
        height="46.308"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.154" />
        <feGaussianBlur stdDeviation="1.577" />
        <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1951_113413" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1951_113413" result="shape" />
      </filter>
      <filter
        id="b"
        x="8.346"
        y="21.865"
        width="18.808"
        height="14.943"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.154" />
        <feGaussianBlur stdDeviation="1.577" />
        <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1951_113413" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1951_113413" result="shape" />
      </filter>
      <filter
        id="c"
        x="15.846"
        y="14.902"
        width="23.808"
        height="21.905"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.154" />
        <feGaussianBlur stdDeviation="1.577" />
        <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1951_113413" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1951_113413" result="shape" />
      </filter>
      <filter
        id="d"
        x="10.846"
        y="10.5"
        width="13.809"
        height="13.81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3.154" />
        <feGaussianBlur stdDeviation="1.577" />
        <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.215686 0 0 0 0 0.270588 0 0 0 0.08 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1951_113413" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1951_113413" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default Image;
